export enum StorageEnum {
  token = '@PE:token',
  student_token = '@PE:student_token',
  institution_token = '@PE:institution_token',
  institution = '@PE:institution_data',
  course = '@PE:couse_data',
  image_course = '@PE:image_couses_data',
  admin = '@PE:admin',
}
